<template>
  <div class="container-page">
    <div>
      <p class="role-card__title mb-6">Карточка роли</p>
      <p v-if="isAccessAllowed" class="role-card__title_name">{{ item.title }}</p>
    </div>
    <TabsListInner v-if="isAccessAllowed">
      <TabsDetailInner v-if="canViewFilters" name="Фильтры по умолчанию" :selected="true">
        <div class="table-container mb-16 js-table-arrow">
          <table class="stockTable">
            <thead>
              <tr>
                <th>Маршрут</th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody v-if="page.items?.length && !isLoading">
              <tr v-for="item in page.items" :key="item.id">
                <td>
                  {{ item.route }}
                </td>
                <td>
                  <a href="javascript:" @click.prevent="onRouteClick(item.route)">Перейти</a>
                </td>
                <td>
                  <IconComponent
                    v-permission="permissions.filterDelete"
                    @click="deleteFilterItem(item.id)"
                    name="delete"
                  />
                </td>
              </tr>
            </tbody>
            <tbody v-else-if="isLoading">
              <tr>
                <td class="text-center" colspan="5">Загрузка...</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td class="text-center" colspan="5">Нет данных.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="page.pagesTotal > 1">
          <Pagination
            :pageCount="page.pagesTotal"
            :currentPage="page.pageNumber"
            @change="onPageChange($event, false)"
            @more="onPageChange($event, true)"
          />
        </div>
        <div>
          <ButtonComponent mod="border" @click="close"> Закрыть </ButtonComponent>
        </div>
      </TabsDetailInner>
      <TabsDetailInner v-if="canViewWidgets" name="Настройка виджетов" :selected="false">
        <table class="widget-table w-100 mb-16">
          <tbody v-if="widgets?.length > 0 && !loadingWidgets">
            <tr v-for="item in widgets" :key="item.id">
              <td class="p-1 w-50">{{ item.name }}</td>
              <td class="checkbox-container w-50">
                <ComponentInput
                  :modelValue="item.roleCanView.some((x) => x == id)"
                  @update:modelValue="onUpdateRole(item, $event)"
                  type="checkbox"
                  :disabled="!canEditWidgets"
                />
              </td>
            </tr>
          </tbody>
        </table>
        <div>
          <ButtonComponent v-if="canEditWidgets" class="mr-8" mod="gradient-bg" @click="updateWidgets">
            Сохранить
          </ButtonComponent>
          <ButtonComponent mod="border" @click="close"> Отмена </ButtonComponent>
        </div>
      </TabsDetailInner>
    </TabsListInner>
  </div>
</template>

<script>
  import ComponentInput from '@/common/components/ComponentInput.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import TabsDetailInner from '@/common/components/TabsDetailInner.vue';
  import TabsListInner from '@/common/components/TabsListInner.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';
  import IconComponent from '@/common/ui/IconComponent.vue';

  import API_WIDGET from '@/modules/home/api/widget';

  import API from '../api/roles';

  const PERMISSIONS = {
    view: Constants.Permissions.RoleView,
    widgetView: Constants.Permissions.WidgetView,
    widgetEdit: Constants.Permissions.WidgetEdit,
    filterView: Constants.Permissions.FilterView,
    filterDelete: Constants.Permissions.FilterDelete,
  };

  export default {
    name: 'RoleCard',
    components: {
      ComponentInput,
      ButtonComponent,
      TabsListInner,
      TabsDetailInner,
      IconComponent,
    },
    mixins: [security],
    data() {
      return {
        id: this.$route.params.id,
        item: {},
        page: {},
        widgets: [],
        request: {
          pageNumber: 1,
          pageSize: Constants.pageSize,
          roleId: this.$route.params.id,
        },
        isLoading: false,
        roleId: null,
        loadingWidgets: false,
        canViewWidgets: false,
        canEditWidgets: false,
        canViewFilters: false,
      };
    },
    async created() {
      const isAllowed = await this.checkPermissionAndRedirect(PERMISSIONS.view);
      if (!isAllowed) return;

      this.checkPermission(PERMISSIONS.filterView).then((response) => {
        this.canViewFilters = response.data;
        if (this.canViewFilters && this.id > 0) {
          this.loadFilters(false);
        }
      });
      this.checkPermission(PERMISSIONS.widgetView).then((response) => {
        this.canViewWidgets = response.data;
        if (this.canViewWidgets) {
          this.loadWidgets();
        }
      });
      this.checkPermission(PERMISSIONS.widgetEdit).then((response) => {
        this.canEditWidgets = response.data;
      });
      this.loadCard();
    },
    computed: {
      permissions() {
        return PERMISSIONS;
      },
    },
    methods: {
      loadWidgets() {
        this.loadingWidgets = true;
        var profile = this.$store.state.auth?.oidc?.profile;
        if (profile == null) profile = JSON.parse(localStorage.getItem('userProfileData'));

        this.roleId = profile.roleIds[0];

        API_WIDGET.getWidgetTypes().then((response) => {
          this.widgets = response.data;
          this.loadingWidgets = false;
        });
      },
      onUpdateRole(item, val) {
        if (val == true) item.roleCanView = [...item.roleCanView, this.id];
        else item.roleCanView = item.roleCanView.filter((x) => x != this.id);
      },
      loadFilters(append) {
        this.isLoading = !append;
        API.searchFilters(this.request)
          .then((response) => {
            if (!append) {
              this.page = {};
              this.$nextTick(() => {
                this.page = response.data;
              });
            } else if (response.data) {
              this.page.pageNumber = response.data.pageNumber;
              this.page.items = this.page.items.concat(response.data.items);
            }
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      },
      onPageChange(pageNumber, addToExist) {
        this.request.pageNumber = pageNumber;
        this.loadFilters(addToExist);
      },
      loadCard() {
        if (this.id > 0) {
          API.find(this.id).then((response) => {
            this.item = response.data;
            if (this.item.isGroupRole)
              this.$router.push({ name: 'RoleGroupCard', params: { id: this.item.id, action: 'edit' } });
          });
        }
      },
      close() {
        this.$router.back();
      },
      onRouteClick(route) {
        this.$router.push({ path: route });
      },
      deleteFilterItem(id) {
        Constants.alert.fire(Constants.confirmOptions.delete).then((res) => {
          if (res.isConfirmed) {
            API.deleteFilter(id)
              .then(() => {
                Constants.alert.fire('Удаление', 'Запись удалена', 'success');
                this.loadFilters(false);
              })
              .catch((error) => {
                Constants.alert.fire(
                  'Удаление',
                  error.response && error.response.data ? error.response.data : 'Запись не удалена',
                  'error',
                );
              });
          }
        });
      },
      updateWidgets() {
        API_WIDGET.updateWidgetTypes(this.widgets)
          .then(() => {
            Constants.alert.fire('Сохранение', Constants.commonSuccess, 'success');
          })
          .catch((error) => {
            Constants.alert.fire(
              'Сохранение',
              error.response && error.response.data ? error.response.data : 'Настройки виджетов не сохранены',
              'error',
            );
          });
      },
    },
    validations() {
      return {
        item: {},
      };
    },
  };
</script>

<style lang="scss" scoped>
  .widget-table {
    td {
      min-height: 32px;
      height: 32px;
    }
  }

  .role-card {
    &__title {
      font: $fira-14;

      &_name {
        font: $fira-24-M;
      }
    }
  }
</style>
